import { useState, useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import styled from "styled-components";
import { toast } from "react-toastify";
import AuthContext from "../context/auth/AuthContext";
import {
  Container,
  Form,
  Group,
  Label,
  Input,
  Button,
} from "../styles/form.elements";

function IniciarSesion() {
  const { usuario, usuarioAutenticado, iniciarSesion } =
    useContext(AuthContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    correo: "",
    clave: "",
  });

  const { correo, clave } = formData;

  useEffect(() => {
    usuarioAutenticado();
    if (usuario) {
      navigate("/");
    }

    return () => {
      formReset();
    };

    // eslint-disable-next-line
  }, [usuario]);

  const formReset = () => {
    setFormData({
      correo: "",
      clave: "",
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (correo === "" || clave === "") {
      toast.error("Por favor provea sus credenciales");
      return;
    }

    const data = {
      correo,
      clave,
    };

    iniciarSesion(data);
  };

  return (
    <Container>
      <Form onSubmit={onSubmit}>
        <h2>Iniciar sesión</h2>
        <Group>
          <Label htmlFor="correo">Correo</Label>
          <Input
            type="mail"
            id="correo"
            name="correo"
            placeholder="Eje: micorreo@servicio.com"
            value={correo}
            onChange={onChange}
          />
        </Group>
        <Group>
          <Label htmlFor="clave">Contraseña</Label>
          <Input
            type="password"
            id="clave"
            name="clave"
            placeholder="Escriba su contraseña"
            value={clave}
            onChange={onChange}
          />
        </Group>
        <Group>
          <Button type="submit">Iniciar sesión</Button>
        </Group>
        <Enlaces>
          <Link to="/olvido-clave">¿Olvido su contraseña?</Link>
          <Link to="/registrar-usuario">Registrarme</Link>
        </Enlaces>
      </Form>
    </Container>
  );
}

const Enlaces = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  a {
    text-decoration: none;
    font-weight: 300;
    color: #004f7f;
    &:hover {
      color: #0ea4ff;
    }
  }
`;

export default IniciarSesion;
